<ion-col>
  <ion-row *ngIf="!!quickOrderItem">
    <div
      [ngClass]="[
        'qoe-product-row',
        quickOrderItem.product?.drawerMsg?.isWarning ? 'product-exception' : ''
      ]"
    >
      <div
        *ngIf="
          quickOrderItem.product?.drawerMsg?.isWarning &&
          (quickOrderItem.product?.drawerMsg?.message ||
            quickOrderItem.product?.drawerMsg?.secondaryMessage)
        "
        class="error-message"
      >
        <ion-icon name="close-circle-outline"></ion-icon>
        <span
          *ngIf="
            quickOrderItem.product?.summary?.cashCarryIndicator === '2' ||
              quickOrderItem.product?.summary?.cashCarryIndicator === '3';
            else mainErrorMessage
          "
        >
          <b>{{
            'i18n.orderInfoSidebar.quickOrderWidget.unableToOrder' | translate
          }}</b>
          {{
            'i18n.orderInfoSidebar.quickOrderWidget.productIsCashAndCarry'
              | translate
          }}
        </span>
        <ng-template #mainErrorMessage>
          <span>
            <b>{{ quickOrderItem.product.drawerMsg.message | translate }}</b>
            {{ quickOrderItem.product.drawerMsg.secondaryMessage | translate }}
          </span>
        </ng-template>
      </div>

      <div class="container">
        <div class="qoe-product-number">
          <div
            class="input-wrapper"
            [ngClass]="[isOnline ? 'enabled' : 'disabled']"
          >
            <ion-input
              *ngIf="toggleSelection === TOGGLE_BTN_PRODUCT_NUMBER"
              [ngClass]="[isOnline ? 'enabled' : 'disabled']"
              [disabled]="!isOnline"
              numeric
              maxlength="7"
              (keyup)="onlyNumbers($event, INPUT_TYPE_PRODUCT_NUMBER)"
              [ngModel]="quickOrderItem.productNumber"
              (keydown.shift.tab)="productNumberUpdate($event)"
              (keydown.enter)="productNumberUpdate($event)"
              (keydown.tab)="productNumberUpdate($event)"
              (ionBlur)="productNumberUpdate($event)"
              (ionFocus)="forceFocus.emit(INPUT_TYPE_PRODUCT_NUMBER)"
              (paste)="pasteFired($event)"
              aria-label="product-number"
              type="tel"
              data-cy="quick-order-entry-product-input"
              [class]="INPUT_TYPE_PRODUCT_NUMBER"
            ></ion-input>
            <ion-input
              *ngIf="toggleSelection === TOGGLE_BTN_CUST_NUMBER"
              [ngClass]="[isOnline ? 'enabled' : 'disabled']"
              [disabled]="!isOnline"
              maxlength="9"
              (keyup)="onlyNumbers($event, INPUT_TYPE_PRODUCT_NUMBER)"
              [ngModel]="quickOrderItem.customerProductNumber"
              (keydown.shift.tab)="productNumberUpdate($event)"
              (keydown.enter)="productNumberUpdate($event)"
              (keydown.tab)="productNumberUpdate($event)"
              (ionBlur)="productNumberUpdate($event)"
              (ionFocus)="forceFocus.emit(INPUT_TYPE_PRODUCT_NUMBER)"
              (paste)="pasteFired($event)"
              aria-label="product-number"
              type="text"
              data-cy="quick-order-entry-product-input"
              [class]="INPUT_TYPE_PRODUCT_NUMBER"
            ></ion-input>
          </div>
        </div>
        <div class="qoe-product-quantity">
          <div
            class="input-wrapper"
            [ngClass]="[isOnline ? 'enabled' : 'disabled']"
          >
            <ion-input
              [disabled]="!isOnline"
              numeric
              maxlength="3"
              [ngClass]="{
                'disabled': !isOnline,
                'product-exception':
                  !!quickOrderItem.product &&
                  !!quickOrderItem.casesOrdered?.currentValue &&
                  !quickOrderItem.product?.orderable
              }"
              (keyup)="onlyNumbers($event, INPUT_TYPE_CASES)"
              [ngModel]="quickOrderItem.casesOrdered?.currentValue"
              (keydown.shift.tab)="hotkey.emit($event)"
              (keydown.enter)="quantityUpdate($event)"
              (keydown.tab)="quantityUpdate($event)"
              (ionBlur)="quantity.emit(quickOrderItem)"
              (ionFocus)="forceFocus.emit(INPUT_TYPE_CASES)"
              (paste)="quantity.emit(quickOrderItem)"
              type="tel"
              aria-label="quantity-cases"
              data-cy="quick-order-entry-cases-input"
              [class]="INPUT_TYPE_CASES"
            >
            </ion-input>
          </div>
          <span class="unit-type">CS</span>

          <div
            class="input-wrapper"
            [ngClass]="[isOnline ? 'enabled' : 'disabled']"
          >
            <ion-input
              [disabled]="!isOnline"
              numeric
              maxlength="3"
              [ngClass]="{
                'disabled': !isOnline,
                'product-exception':
                  !!quickOrderItem.product &&
                  !!quickOrderItem.eachesOrdered?.currentValue &&
                  (!quickOrderItem.product?.summary?.breakable ||
                    !quickOrderItem.product?.orderable)
              }"
              (keyup)="onlyNumbers($event, INPUT_TYPE_EACHES)"
              [ngModel]="quickOrderItem.eachesOrdered?.currentValue"
              (keydown.shift.tab)="hotkey.emit($event)"
              (keydown.enter)="quantityUpdate($event)"
              (keydown.tab)="quantityUpdate($event)"
              (ionBlur)="quantity.emit(quickOrderItem)"
              (ionFocus)="forceFocus.emit(INPUT_TYPE_EACHES)"
              (paste)="quantity.emit(quickOrderItem)"
              type="tel"
              aria-label="quantity-eaches"
              data-cy="quick-order-entry-each-input"
              [class]="INPUT_TYPE_EACHES"
            ></ion-input>
          </div>
          <span class="unit-type">EA</span>
        </div>
        <div class="qoe-product-desc">
          <p
            *ngIf="!!quickOrderItem.product?.summary?.productDescTxtl"
            data-cy="quick-order-entry-product-description-text"
          >
            {{
              quickOrderItem.product?.summary?.productDescTxtl
                | acronymTitleCase
            }}
            {{
              toggleSelection === TOGGLE_BTN_CUST_NUMBER
                ? '#' + quickOrderItem.productNumber
                : ''
            }}
          </p>
        </div>
        <div
          *ngIf="
            !quickOrderItem.product?.summary?.propertiesArray?.includes(
              propertiesEnum.specialOrder
            );
            else noPrice
          "
          class="qoe-product-price"
          data-cy="quick-order-entry-price-text"
        >
          <div *ngIf="quickOrderItem.product?.pricing?.unitPrice as unitPrice">
            ${{ unitPrice }} CS
          </div>
          <div
            *ngIf="
              quickOrderItem.product?.summary?.breakable &&
              quickOrderItem.product?.pricing?.eachPrice as eachPrice
            "
          >
            ${{ eachPrice }} EA
          </div>
        </div>
        <ng-template #noPrice>
          <div class="qoe-product-price" data-cy="quick-order-entry-price-text">
            <div>
              {{ 'i18n.orderPage.noPrice' | translate }}
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </ion-row>
</ion-col>
